"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var styles = _crossPlatformComponents.StyleSheet.create({
  widgetModalHeader: {
    flexDirection: 'row',
    width: '100%',
    height: 56,
    backgroundColor: '#fff',
    borderColor: '#fff',
    borderBottomWidth: 0,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 9,
    ios: {
      backgroundColor: '#fff',
      height: 44
    }
  },
  headerCloseIcon: {
    position: 'absolute',
    top: 15,
    zIndex: 9999,
    ios: {
      top: 10
    }
  },
  bannerIcon: {
    ios: {
      width: 32,
      height: 32
    },
    android: {
      width: 32,
      height: 32
    },
    marginLeft: 0,
    marginRight: 0
  },
  headerTitle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  headerTextStyle: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    ios: {
      fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
      fontWeight: '600'
    }
  },
  headerImage: {
    resizeMode: 'cover',
    justifyContent: 'center',
    width: '100%',
    height: 153
  },
  headerBackButton: {
    position: 'absolute',
    top: 20,
    left: 20,
    zIndex: 9999,
    borderRadius: 50,
    backgroundColor: '#2121244C',
    web: {
      padding: 8
    },
    android: {
      padding: 5
    },
    ios: {
      padding: 5
    }
  }
});

var _default = styles;
exports["default"] = _default;